import { reduxForm } from 'redux-form'
import LoginForm from '.'
import validate from './validate'

export default reduxForm({
  form: 'login-form',
  validate,
  touchOnBlur: false
})(LoginForm)
